/* eslint-disable import/no-anonymous-default-export */
import { api } from "./apiServices";

export const loginUser = (user) => api().post("/admin/admin-login", user).then(handleResponse);
export const createUser = (token, user) => api(token).post("/admin/admin-create-user", user).then(handleResponse);
export const updateAdminPassword = (token, data) => api(token).post("/admin/admin-password-update", data).then(handleResponse);
export const updateUser = (token, id, user) => api(token).post("/admin/admin-update-user/" + id, user).then(handleResponse);
export const getUser = (token, user) => api(token).post("/admin/admin-user-get", user).then(handleResponse);
export const getGroups = (token, user) => api(token).post("/admin/admin-group-get", user).then(handleResponse);
export const createGroup = (token, user) => api(token).post("/admin/admin-create-group", user).then(handleResponse);
export const updateGroup = (token, id, user) => api(token).post("/admin/admin-update-group/" + id, user).then(handleResponse);
export const uploadLogo = (token, data) => api(token).post("/admin/logo-update/", data).then(handleResponse);
export const getTrackingData = (token, data) => api(token).post("/admin/admin-tracking-get/", data).then(handleResponse);
export const getTrackingDataExport = (token, data) => {
  return api(token).post("/admin/admin-tracking-export/", data, {
    responseType: "blob"
  });
};

export const getLogData = (token, data = {}) =>
  api(token)
    .get("/admin/get-warnings", { params: data })
    .then(handleResponse);
export const getDayWiseTracking = (token, data) => api(token).post("/admin/admin-day-wise-tracking-get/", data).then(handleResponse);
export const deleteTrackingData = (token, data) => api(token).post("/admin/admin-tracking-delete/", data).then(handleResponse);
export const updateBillingDetails = (token, id, data) => api(token).post("/admin/admin-update-billing-details/" + id, data).then(handleResponse);
export const deleteUser = (token, id) => api(token).delete("/admin/admin-user-delete/" + id).then(handleResponse);
export const logoutUser = (token, id) => api(token).delete("/admin/admin-user-logout/" + id).then(handleResponse);
export const deleteGroup = (token, id) => api(token).delete("/admin/admin-group-delete/" + id).then(handleResponse);
export const getSuggestions = (token) => api(token).delete("/admin/get-work-suggestion").then(handleResponse);
export const getDashboardData = (token) => api(token).get("/admin/get-dashboard-data").then(handleResponse);
export const getDepartments = (token, dep) => api(token).post("/admin/admin-get-department", dep).then(handleResponse);
export const createDepartment = (token, dep) => api(token).post("/admin/admin-create-department", dep).then(handleResponse);
export const updateDepartment = (token, id, dep) => api(token).post("/admin/admin-update-department/" + id, dep).then(handleResponse);
export const deleteDepartment = (token, id) => api(token).delete("/admin/admin-delete-department/" + id).then(handleResponse);
export const getUserById = (token, id) => api(token).get("/admin/get-user-by-id/" + id).then(handleResponse);
export const updateSetting = (token, id, data) => api(token).post("/admin/admin-update-userSetting/" + id, data).then(handleResponse);
export const getScreenShots = (token, data) => api(token).get("/admin/get-screenshots/", { params: data }).then(handleResponse);
export const deleteScreenShot = (token, data) => api(token).post("/admin/delete-screenshots/", data).then(handleResponse);
export const getUserChat = (token, sender, receiver, data) => api(token).get(`/admin/get-user-chat/${sender}/${receiver}/?page=${data.page}&limit=${data.limit}&searchTerm=${data.searchTerm}`).then(handleResponse);
export const getGroupChat = (token, groupId, data) => api(token).get(`/admin/get-group-chat/${groupId}/?page=${data.page}&limit=${data.limit}&searchTerm=${data.searchTerm}`).then(handleResponse);
export const updatePermissions = (token, data) => api(token).post("/admin/create-permissions", data).then(handleResponse);


export const getUserChatExport = (token, sender, receiver, data) => {
  return api(token).post(
    `/admin/export-user-chat/${sender}/${receiver}`,
    data,
    { responseType: "blob" }
  );
};

export const getGroupChatExport = (token, groupId, data) => {
  return api(token).post(
    `/admin/export-group-chat/${groupId}`,
    data,
    { responseType: "blob" }
  );
};


const handleResponse = (response) => {
  let data = response.data;
  if (response.data.code == 6) {
    localStorage.removeItem("token");
    window.location.href = "/"
  }
  return data;
};
